/** ScoreDashboard Suspend toggle success toast (Lab Suspended / Unsuspended). */
export function submarketSuspendToast(name: string, nextVal: boolean): string {
  const label = String(name || '').trim() || 'Submarket'
  return nextVal
    ? `Submarket Suspended For ${label}`
    : `Submarket Unsuspended For ${label}`
}
